import { RotaDrawer } from 'screens/Rostering/RotaDrawer'

type MonitoringRotaDrawerProps = {
  isVisible: boolean
  onClose: () => void
  revisionId: string
}

const MonitoringRotaDrawer = ({
  isVisible,
  onClose,
  revisionId,
}: MonitoringRotaDrawerProps) => {
  return <RotaDrawer onClose={onClose} isVisible={isVisible} id={revisionId} />
}

export default MonitoringRotaDrawer
